import { createSelector } from 'reselect'
import moment from 'moment'
import { dateFormat } from 'common/utils/time'
import {
  getSearchOrigin,
  getSearchDestination,
  getSearchOutboundDateTime,
  getSearchInboundDateTime,
  getSearchPax,
} from 'tickets/redux/modules/router/selectors'

const getOriginKind = (state) => state.searchParams.originKind
const getDestinationKind = (state) => state.searchParams.destinationKind
const getOriginLatLng = (state) => state.searchParams.originLatLng
const getDestinationLatLng = (state) => state.searchParams.destinationLatLng
const getOriginGooglePlaceId = (state) => state.searchParams.originGooglePlaceId
const getDestinationGooglePlaceId = (state) => state.searchParams.destinationGooglePlaceId
const getOriginLongName = (state) => state.searchParams.originLongName
const getDestinationLongName = (state) => state.searchParams.destinationLongName
const getHandoverModeId = (state) => state.searchParams.handoverModeId

const getSearchPaxCount = createSelector(
  [getSearchPax],
  (pax) => pax.length
)

const getSearchIsReturn = createSelector(
  [getSearchOutboundDateTime, getSearchInboundDateTime],
  (outboundDateTime, inboundDateTime) => !!(outboundDateTime && inboundDateTime)
)

const getSearchIsValid = createSelector(
  [
    getSearchOrigin,
    getSearchDestination,
    getSearchOutboundDateTime,
    getSearchInboundDateTime,
    getSearchPaxCount,
    getSearchIsReturn,
  ],
  (origin, destination, outboundDateTime, inboundDateTime, paxCount, isReturn) => {
    if (origin == '') return false
    if (destination == '') return false
    if (outboundDateTime == null) return false
    if (!moment(outboundDateTime, dateFormat).isValid()) return false
    if (moment(outboundDateTime, dateFormat).isBefore(moment().startOf('day'))) return false
    if (isReturn) {
      if (inboundDateTime == null) return false
      if (!moment(inboundDateTime, dateFormat).isValid()) return false
      if (moment(inboundDateTime, dateFormat).isBefore(moment(outboundDateTime, dateFormat))) {
        return false
      }
    }
    if (paxCount <= 0) return false
    return true
  }
)

const getIsDropOff = createSelector(
  [getOriginKind],
  // Lowercase until backend can lower case it
  (originKind) => (originKind && originKind.toLowerCase() == 'airport')
)

const getLocation = createSelector(
  [getIsDropOff, getOriginLatLng, getDestinationLatLng],
  (isDropOff, originLatLng, destinationLatLng) => (
    (isDropOff) ? destinationLatLng : originLatLng
  )
)

export {
  getSearchPaxCount,
  getSearchIsReturn,
  getSearchIsValid,
  getIsDropOff,
  getLocation,
  getOriginKind,
  getDestinationKind,
  getOriginGooglePlaceId,
  getDestinationGooglePlaceId,
  getOriginLongName,
  getDestinationLongName,
  getOriginLatLng,
  getDestinationLatLng,
  getHandoverModeId,
}
